export const getDomainStatus = (valid, lastValidationAttemptAt) => {
  if (valid && lastValidationAttemptAt) {
    return 'validated'
  } else if (lastValidationAttemptAt) {
    return 'failed'
  } else {
    return 'pending'
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/EmailSetting/utils.js